export default __webpack_public_path__ + "static/media/logo.cbbc60b2.png";